import React, { createContext, useEffect, useState } from "react";

import { PropsType } from "../../interfaces/ChildrenType";

import { CreditProposalResult } from "../../interfaces/CreditProposalResult";

import { CreditProposalResultContextType } from "./creditProposalResult-types";

const creditProposalData = sessionStorage.getItem("CEX-creditProposal");
const initialState: CreditProposalResultContextType = {
  creditProposalResult: JSON.parse(creditProposalData as string) || undefined,

  setCreditProposalResult: () => { },
};

export const CreditProposalResultContext = createContext(initialState);

export const CreditProposalResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [creditProposalResult, setCreditProposalResult] = useState<
    CreditProposalResult | undefined
  >(initialState.creditProposalResult);

  useEffect(() => {
    if (creditProposalResult) {
      sessionStorage.setItem('CEX-creditProposal', JSON.stringify(creditProposalResult))
    } else {
      sessionStorage.removeItem("CEX-creditProposal");
    }
  }, [creditProposalResult])

  return (
    <CreditProposalResultContext.Provider
      value={{ creditProposalResult, setCreditProposalResult }}
    >
      {children}
    </CreditProposalResultContext.Provider>
  );
};
